var map = {
	"./assignment.png": 1188,
	"./attendance.png": 9062,
	"./auto-attendance.png": 3557,
	"./book.png": 1072,
	"./box.png": 3023,
	"./certificate.png": 1537,
	"./chat.png": 8674,
	"./database.png": 180,
	"./demostration.png": 4674,
	"./feedback.png": 9723,
	"./file.png": 6169,
	"./folder.png": 7664,
	"./forum.png": 5531,
	"./glossary.png": 6666,
	"./help.png": 1122,
	"./ims-content-package.png": 3203,
	"./lesson.png": 55,
	"./message.png": 5588,
	"./page.png": 4595,
	"./problem-solving.png": 8952,
	"./quiz.png": 1172,
	"./satisfaction.png": 354,
	"./survey.png": 9977,
	"./training-event.png": 6631,
	"./url.png": 5493,
	"./vocabulary.png": 8782,
	"./wiki.png": 1862,
	"./workshop.png": 8825,
	"./zoom-meeting.png": 1672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2231;